module.exports = __webpack_public_path__ + "static/media/dca_itdel_logo.783552fd.png";